import { currencyString } from '@sales-center/common'
import { useCallback } from 'react'

export function useGetCurrencyStringWithNegativePricingEnabled() {
  return useCallback((value: string | number) => currencyString(value), [])
}
